<ng-container *rxFor="let absence of absences; trackBy: trackByAbsenceDetail">
  @if (
    {
      isFeatureFlagEnable:
        'Shift-timeline-page-absence-edit-drawer' | featureFlagPure | async,
      left: absence.absentFrom | ganttStartingPixel | async,
      right: [absence.absentFrom, absence.absentTo] | ganttEndingPixel | async,
      isMoveMode: dragAndDropModeService.isMoveMode$ | async,
      staffLayoutStyle: staffLayoutStyle$ | async,
      absenceDuration:
        absence.absentFrom | differenceInMilliseconds: absence.absentTo,
    };
    as data
  ) {
    @let template =
      deferredAbsenceTimelineViewCardHelperService.getPreviewTemplate();
    @defer (on hover) {
      @let hasAbsenceUpdatePermissions =
        can(RoleAction.Update, RolePermissionSubject.Absence);
      <div
        [draggable]="data.isMoveMode"
        (dragstart)="
          startDrag(
            $event,
            data.left,
            data.right,
            absence,
            dragImage,
            !!hasAbsenceUpdatePermissions
          )
        "
        (dragend)="dragEnd(!!data.isMoveMode)"
        (drag)="
          hasAbsenceUpdatePermissions &&
            data.isMoveMode &&
            trackHorizontalDrag(
              $event,
              data.left,
              data.right,
              data.absenceDuration
            )
        "
        (click)="
          data.isFeatureFlagEnable &&
            selectAbsence(
              {
                left: data.left,
                right: data.right,
                id: absence.id,
              },
              undoTemplate
            )
        "
      >
        <ng-container
          *ngTemplateOutlet="
            template;
            context: {
              dashedBorder: draggingAsenceId === absence.id,
              lowOpacity:
                !absence['isHighlighted'] || draggingAsenceId === absence.id,
              leftPx: data.left,
              rightPx: data.right,
              absenceTitle:
                (absence | getAbsenceTimelineCardTitle | async) || '',
              absenceCategoryId: absence.absenceCategoryId,
              absenceStatus: absence.status,
              absenceHalfDayStart: !!absence.halfDayStart,
              absenceHalfDayEnd: !!absence.halfDayEnd,
              startFrom: absence.absentFrom,
              until: absence.absentTo,
              loading: loadingAbsenceIds.includes(absence.id || ''),
              isMinimalHeight:
                data.staffLayoutStyle === StaffLayoutStyle.Minimal,
              isOverlapDetected: isOverlapDetected,
              absenceHeight: absenceHeight,
              absenceTooltip: absencetooltip,
            }
          "
        >
        </ng-container>
        <ng-template #absencetooltip>
          <wilson-timeline-absence-tooltip [absence]="absence">
          </wilson-timeline-absence-tooltip>
        </ng-template>
      </div>
    } @placeholder {
      <div>
        <ng-container
          *ngTemplateOutlet="
            template;
            context: {
              dashedBorder: draggingAsenceId === absence.id,
              lowOpacity:
                !absence['isHighlighted'] || draggingAsenceId === absence.id,
              leftPx: data.left,
              rightPx: data.right,
              absenceTitle:
                (absence | getAbsenceTimelineCardTitle | async) || '',
              absenceCategoryId: absence.absenceCategoryId,
              absenceStatus: absence.status,
              absenceHalfDayStart: !!absence.halfDayStart,
              absenceHalfDayEnd: !!absence.halfDayEnd,
              startFrom: absence.absentFrom,
              until: absence.absentTo,
              loading: loadingAbsenceIds.includes(absence.id || ''),
              isMinimalHeight:
                data.staffLayoutStyle === StaffLayoutStyle.Minimal,
              isOverlapDetected: isOverlapDetected,
              absenceHeight: absenceHeight,
              absenceTooltip: null,
            }
          "
        >
        </ng-container>
      </div>
    }
  }
</ng-container>

<div id="move-activity" class="move-preview" #dragImage></div>

<ng-template #undoTemplate>
  <wilson-nz-message-timer-line [duration]="MESSAGE_DURATION">
    <wilson-message-with-undo-option
      (undo)="onUndo()"
    ></wilson-message-with-undo-option>
  </wilson-nz-message-timer-line>
</ng-template>
